<template>
    <div class="header-search">
            <form class="search-form" @submit.prevent>

                <div class="search-form-input" :class="{'search-focused': searchFocus}" >
                    <input type="text"
                           ref="search"
                           placeholder="New search"
                           v-model="searchValue"
                           @keyup="debounce($event.target.value, 400, $event.keyCode)"
                           @focus.prevent="setSearchFocus(true)"
                           v-clickoutside="exitSuggestion"
                    >
                  <div v-if="!searchFocus" class="search-form-input-icon search" @click.prevent="setSearch(searchValue)"> </div>
                  <div v-if="searchFocus" class="search-form-input-icon close" @click.prevent="exitSuggestion()"> </div>
                </div>

                <div class="search-form-suggestions" :class="{'has-suggestions': keywordSuggestion.length, 'show': searchValue && showSuggestion && searchFocus}">
                    <div class="suggestion" v-for="(keyword, index) in keywordSuggestion" :key="index" :id="'search_' + index" @click.self.stop="setSearch(keyword, true)">
                        {{ keyword }}
                    </div>
                    <div v-if="searchValue && showSuggestion" :class="{'suggestion': true, 'button': true, 'has-suggestions': keywordSuggestion.length}" id="search_input" @click.self.stop="setSearch(searchValue)">
                        view all results
                    </div>
                </div>

            </form>
     </div>

</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'HeaderSearch',
  data () {
    return {
      searchFocus: false,
      searchValue: null,
      showSuggestion: false,
      keywordSuggestion: [],
      favoritesMenu: false
    }
  },
  directives: {
    clickoutside: {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
      stopProp (event) { event.stopPropagation() }
    }
  },
  methods: {
    debounce (search, debounceDuration = 300, key = null) {
      if (key === 13) {
        this.setSearch(search)
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId)
        }
        return
      }

      if (key === 27) {
        if (this.$route.name === 'home') {
          this.setSearch('')
          this.setSearchFocus(false)
          this.$refs.search.blur()
        } else {
          this.searchValue = ''
        }
        return
      }

      let scope = this
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId)
      }
      this.timeoutId = setTimeout(_ => {
        scope.setKeywordSearch(search)
      }, debounceDuration)
    },
    setKeywordSearch (keyword) {
      this.showSuggestion = true
      this.keywordSuggestion = []
      if (!(!keyword || /^\s*$/.test(keyword))) {
        HTTP({
          method: 'GET',
          url: '/api/v1/assets/autocomplete',
          crossdomain: true,
          params: {
            term: keyword
          }
        }).then(response => {
          if (this.showSuggestion) {
            if (response.data.data) {
              this.keywordSuggestion = response.data.data
            }
          }
        }).catch(() => {
          this.keywordSuggestion = []
        })
      }
    },
    setSearch (searchString, quotes = false) {
      this.showSuggestion = false
      this.searchValue = ''
      this.setSearchFocus(false)
      this.keywordSuggestion = []

      if (this.$route.name === 'home') {
        this.$store.dispatch('setAssetQuery', {
          search: quotes ? '"' + searchString + '"' : searchString
        })

        EventBus.$emit('search', true)
      } else {
        this.$router.push({ name: 'home', params: { search: searchString } })
      }
    },
    setSearchFocus (value) {
      this.searchFocus = value
      if (value === false) {
        this.$refs.search.blur()
      }
    },
    exitSuggestion () {
      this.setSearchFocus(false)
    }
  }
}
</script>
